import { createSignal } from '@verclam/pulsar';

/** `null` when no deactivation is pending confirmation; otherwise the id of the user to confirm. */
const userToDeactivateSignal = createSignal<number | null>(null);

export const setUserToDeactivate = (userId: number | null): void => {
	userToDeactivateSignal.value = userId;
};

export default userToDeactivateSignal;
